import React, { useEffect, useState } from "react";
import PaginationComponent from "../searchApp/Pagination/PaginationComponent.jsx";
import LoadingSpinner from "../searchApp/LoadingSpinner/LoadingSpinner.jsx";
const App = () => {
  const [params, setParams] = useState({
    hitsPerPage: window?.hoasPagination?.params?.hitsPerPage,
    page: window?.hoasPagination?.params?.page,
  });

  const [count, setCount] = useState(parseInt(window?.hoasPagination?.total));
  const [loading, setLoading] = useState(false);

  const callBackUrlQuery = (clickedParams) => {
    if (clickedParams.page !== params.page) {
      setLoading(true);
      let url = new URL(window.location.href);
      const namespace = window?.hoasPagination?.usePaged ? "paged" : "page";
      url.searchParams.set(namespace, clickedParams.page);
      window.location.href = url;
    }
  };

  return (
    <div className="d-flex justify-content-center">
      {loading ? (
        <LoadingSpinner />
      ) : (
        <PaginationComponent
          params={params}
          count={count}
          callBackUrlQuery={callBackUrlQuery}
        />
      )}
    </div>
  );
};

export default App;
